/**
 * Kép tömörítése feltöltés előtt (telefonos fotók 3–8 MB → ~150–400 kB JPEG).
 * EXIF-forgatást a böngésző createImageBitmap kezeli (imageOrientation: 'from-image').
 */
export async function compressImage(file: File | Blob, maxSide = 1600, quality = 0.82): Promise<{ blob: Blob; width: number; height: number }> {
  let bitmap: ImageBitmap | HTMLImageElement;
  try {
    bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' } as any);
  } catch {
    bitmap = await new Promise<HTMLImageElement>((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('A kép nem olvasható')); };
      img.src = url;
    });
  }
  const sw = (bitmap as any).width, sh = (bitmap as any).height;
  const scale = Math.min(1, maxSide / Math.max(sw, sh));
  const w = Math.max(1, Math.round(sw * scale)), h = Math.max(1, Math.round(sh * scale));
  const canvas = document.createElement('canvas');
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas nem elérhető');
  ctx.drawImage(bitmap as any, 0, 0, w, h);
  if ('close' in bitmap) (bitmap as ImageBitmap).close();
  const blob = await new Promise<Blob | null>(res => canvas.toBlob(res, 'image/jpeg', quality));
  if (!blob) throw new Error('A tömörítés nem sikerült');
  return { blob, width: w, height: h };
}

/** Kép URL → dataURL (PDF-be ágyazáshoz). Hibánál null. */
export async function urlToDataUrl(url: string, maxSide = 1200): Promise<string | null> {
  try {
    const res = await fetch(url, { mode: 'cors' });
    if (!res.ok) return null;
    const blob = await res.blob();
    const { blob: small } = await compressImage(blob, maxSide, 0.8);
    return await new Promise<string>((resolve, reject) => { const r = new FileReader(); r.onload = () => resolve(String(r.result)); r.onerror = reject; r.readAsDataURL(small); });
  } catch {
    return null;
  }
}
